import React, { useContext, useMemo, useState } from 'react'
import contactStyle from "../../../../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss"
import globalStyles from "../../../../../assets/styles/global.module.scss";
import styles from "../../../../../assets/styles/componentStyles/chats/smartAssist.module.scss";
import whatsAppCampaignStyles from "../../../../../assets/styles/componentStyles/whatsappCampaignStyles/whatsappCampaignStyle.module.scss"
import { Accordion, AccordionDetails, AccordionSummary, Box, CircularProgress, Divider, Grid, TextField, Typography } from '@mui/material';
import { chatbotDataConnector, smartAssistPayload } from '../../../../../models/axiosModel';
import GlobalButton from '../../../../../components/utility/globalButton/button';
import { UserContext, UserContextPayload } from '../../../../../context/userContext';
import { JsonToTable } from "react-json-to-table";
import { greyColor, redColor } from '../../../../../utils/colors';
import IconsColor from '../../../../../components/utility/iconsColor';
import { hasCustomAPIPageManageAccess } from '../../../../../utils/constants';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import axios from 'axios';
import { getVendorField } from '../../../../../utils/whiteLabelling';
import { normalizeValuesToStrings } from '../../../utils';
import { getSmartAssistStatusInfo } from '../../../renderUtils';
import clsx from "clsx";

interface smartAssistRunToolPopupProps {
    dataConnectorDetails: chatbotDataConnector | null,
    payload: smartAssistPayload | null,
    setPayload: React.Dispatch<React.SetStateAction<smartAssistPayload | null>>,
    setFlagRunDataConnectorToolPopup: React.Dispatch<React.SetStateAction<boolean>>,
}

const SmartAssistRunToolPopup: React.FC<smartAssistRunToolPopupProps> = (props) => {

    const { dataConnectorDetails, payload, setPayload, setFlagRunDataConnectorToolPopup } = props;

    const { userDetail, apiRoutesPermissionAssignment, vendorData } = useContext(UserContext) as UserContextPayload
    const [functionCallingResponse, setFunctionCallingResponse] = useState<any>(null);
    const [isLoadingResponse, setIsLoadingResponse] = useState<boolean>(false);
    const innerHeight = window.innerHeight - 80;
    const innerHeightForLoader = window.innerHeight - 450;

    const [flagRequestFailed, setFlagRequestFailed] = useState<boolean | null>(null);

    const checkDisableRunToolBtn = () => {
        if (!payload?.request_parameters || !payload.chatbot_data_connector_id || isLoadingResponse) return true;

        return Object.entries(payload.request_parameters).some(([key, value]) => {
            if (!isReqParamRequired(key)) return false;
            if (value === null || value === undefined) return true;
            return String(value).trim().length === 0;
        });
    }

    const onClickOfRunTool = async () => {
        if(payload){
            setIsLoadingResponse(true);
            try {
                const res: any = await axios.post(`${getVendorField(vendorData, "backend api", process.env.REACT_APP_BASE_URL)}/api/inbox/call-custom-api`, payload, {
                    headers: {
                        "Content-Type": "application/json"
                    }
                });
                if(res?.data?.data){
                    setFunctionCallingResponse(normalizeValuesToStrings(res?.data?.data));
                }
            } catch(err: unknown) {
                if(axios.isAxiosError(err)){
                    if(err && err?.response && err?.response?.status && err?.response?.status != 200){
                        setFlagRequestFailed(true);
                    }

                    if(err && err?.response && err?.response?.data){
                        setFunctionCallingResponse(normalizeValuesToStrings(err.response.data));
                    }
                } else {
                    console.error("Unexpected error: ", err);
                }
            }
            setIsLoadingResponse(false);
        }
    }

    const shouldRenderRequestParamSection = () => {
        return (payload?.request_parameters && Object.keys(payload.request_parameters).length > 0);
    }

    const onChangeOfValue = (key: string, value: string) => {
        setPayload((prevPayload: smartAssistPayload | null) => {
            if(!prevPayload) return prevPayload;
            return {
                ...prevPayload,
                request_parameters: {
                    ...prevPayload.request_parameters,
                    [key]: value,
                },
            };
        });
    }

    const isReqParamRequired = (key: string) => {
        return dataConnectorDetails?.data_connector_functions?.data_connector_function_parameters?.function_parameter_data?.find((param) => param?.function_parameter_name == key)?.function_parameter_required_flag ?? false;
    }

    const getParameterType = (param: string) => {
        if (dataConnectorDetails) {
            const functionParameter = dataConnectorDetails?.data_connector_functions?.data_connector_function_parameters?.function_parameter_data?.find((params) => params?.function_parameter_name == param);
            if (functionParameter) {
                const type = functionParameter?.function_parameter_type_name;
                return `${type.charAt(0).toUpperCase()}${type.slice(1)}`;
            }
        }
        return "";
    }

    const handleClearAndRestart = () => {
        setFunctionCallingResponse(null);
        setPayload((prev: smartAssistPayload | null) => {
            if(!prev) return prev;

            const clearedParams = Object.keys(prev.request_parameters).reduce(
                (acc, key) => {
                    acc[key] = "";
                    return acc;
                },
                {} as { [key: string]: string }
            );
            return {
                ...prev,
                request_parameters: clearedParams
            }
        })
    }

    const getParamGridSize = () => {
        const paramsCount = payload && Object.keys(payload?.request_parameters)?.length || 0;
        return paramsCount < 3 ? 6 : 4;
    }

    const shouldShowReqParamFields = useMemo(() => {
        return shouldRenderRequestParamSection() && !functionCallingResponse && !isLoadingResponse;
    }, [shouldRenderRequestParamSection(), functionCallingResponse, isLoadingResponse]);

    const shouldShowSmartAssistStatusInfo = useMemo(() => {
        return ((functionCallingResponse || flagRequestFailed) && !isLoadingResponse);
    }, [functionCallingResponse, flagRequestFailed, isLoadingResponse])

    return (
        <>
            <Grid container sx={{ maxHeight: `${innerHeight}px`, height: `${innerHeight}px` }} className={clsx(globalStyles.displayFlexStyle, globalStyles.flexColumn)} justifyContent={"center"} >
                <Grid item className={styles.smartAssistToolTitle}>
                    <Grid container gap={1} alignItems={"center"} className={`${globalStyles.displayFlexStyle}`}>
                        <Grid item>
                            <AutoFixHighIcon className={styles.smartAssistIcon} />
                        </Grid>
                        <Grid item>
                            <Grid container className={clsx(globalStyles.displayFlexStyle, globalStyles.flexColumn)}>
                                <Typography className={`${styles.smartAssistTitleText}`}>
                                    Smart Assist Tool
                                </Typography>
                                <Typography className={clsx(globalStyles.secondaryFontSize, globalStyles.primaryFontWeight, globalStyles.greyColor)}>
                                    {dataConnectorDetails?.data_connector_functions?.data_connector_function_name}
                                </Typography>
                            </Grid>
                        </Grid>  
                    </Grid>
                </Grid>

                <Divider className={contactStyle.popupTitleDivider} />

                <Grid item className={styles.smartAssistRunToolPopupBodyGrid}>
                    <Grid container className={`${contactStyle.popupBodyGridContainer}`} gap={2}>

                        <Grid item className={clsx(globalStyles.fullwidth, styles.aboutToolGrid)}>
                            <Grid container gap={1} className={clsx(globalStyles.displayFlexStyle, globalStyles.flexColumn)}>
                                <Grid item>
                                    <Grid container className={clsx(globalStyles.displayFlex, globalStyles.justifyContentSpaceBetween)}>
                                        <Grid item>
                                            <Grid container className={globalStyles.displayFlex} gap={1}>
                                                <Grid item className={globalStyles.displayFlex}>
                                                    <IconsColor fillColor={greyColor} iconName="info" height={"14"} width={"14"} />
                                                </Grid>
                                                <Grid item>
                                                    <Typography className={clsx(globalStyles.secondaryFontSize, globalStyles.secondaryFontWeight, globalStyles.greyColor)}>
                                                        About this tool
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        {hasCustomAPIPageManageAccess(apiRoutesPermissionAssignment, userDetail) && 
                                            <Grid item className={globalStyles.clickable} onClick={() => window.open(`/customAPI/createCustomAPI?connector_id=${dataConnectorDetails?.chatbot_data_connector_id}`, "_blank")}>
                                                <Grid container gap={1} className={globalStyles.displayFlex}>
                                                    <Grid item>
                                                        <Typography className={clsx(styles.manageTool, globalStyles.tertiaryFontSize, globalStyles.secondaryFontWeight)}>
                                                            Manage Tool
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item>
                                                        <OpenInNewIcon className={clsx(globalStyles.displayFlex, styles.manageToolIcon)} />
                                                    </Grid>
                                                </Grid>
                                            </Grid> 
                                        }
                                    </Grid>
                                </Grid>
                                <Grid item>
                                    <Typography className={clsx(globalStyles.tertiaryFontSize, globalStyles.secondaryFontWeight)}>
                                        {dataConnectorDetails?.data_connector_functions?.data_connector_function_description ?? ""}
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>

                        {shouldShowReqParamFields && 
                            <Grid item className={globalStyles.fullwidth}>
                                <Grid container gap={3} className={clsx(globalStyles.displayFlexStyle, globalStyles.flexColumn)}>
                                    <Grid item>
                                        <Typography className={clsx(globalStyles.primaryFontSize, globalStyles.secondaryFontWeight)}>
                                            Enter Details
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Grid container spacing={3} className={globalStyles.displayFlex}>
                                            {payload && payload?.request_parameters && Object.keys(payload?.request_parameters).map((key: string) => {
                                                return (
                                                    <Grid item xs={12} sm={12} md={6} lg={getParamGridSize()}>
                                                        <Grid container gap={1} className={clsx(globalStyles.displayFlexStyle, globalStyles.flexColumn)}>
                                                            <Grid item>
                                                                <Grid container className={clsx(globalStyles.displayFlex, globalStyles.justifyContentSpaceBetween)}>
                                                                    <Grid item>
                                                                        <Grid container gap={1} className={globalStyles.displayFlex}>
                                                                            <Typography className={clsx(globalStyles.secondaryFontSize, globalStyles.secondaryFontWeight)}>
                                                                                {key}
                                                                            </Typography>
                                                                            {isReqParamRequired(key) && 
                                                                                <Grid item className={styles.requiredParamChip} sx={{ backgroundColor: `${redColor}1A` }}>
                                                                                    Required
                                                                                </Grid>
                                                                            }
                                                                        </Grid>
                                                                    </Grid>
                                                                    <Grid item className={styles.parameterTypeChip}>
                                                                        {getParameterType(key)}
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>
                                                            <Grid item>
                                                                <TextField
                                                                    value={payload?.request_parameters[key]}
                                                                    placeholder={`Enter ${key}`}
                                                                    onChange={(e) => onChangeOfValue(key, e.target.value)}
                                                                    className={`${whatsAppCampaignStyles.whatsappCampaignTextField} ${globalStyles.fullwidth} ${styles.smartAssistRequestParamsValueTextField}`}
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                );   
                                            })}
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        }

                        {isLoadingResponse && (
                            <Grid item className={globalStyles.fullwidth} sx={{ minHeight: innerHeightForLoader }}>
                                <Box className={clsx(globalStyles.displayFlex, globalStyles.justifyCenter, globalStyles.alignItemCenter, globalStyles.flexColumn, globalStyles.fullwidth)} sx={{ minHeight: innerHeightForLoader, gap: 2 }}>
                                    <CircularProgress />
                                    <Typography className={clsx(globalStyles.secondaryFontSize, globalStyles.secondaryFontWeight)} color="text.secondary">
                                        Fetching Info...
                                    </Typography>
                                </Box>
                            </Grid>
                        )}  

                        {shouldShowSmartAssistStatusInfo && 
                            <>
                                <Grid item className={globalStyles.fullwidth} xs={12}>
                                    <Grid container gap={2} className={clsx(globalStyles.displayFlex, globalStyles.flexColumn)}>

                                        {shouldRenderRequestParamSection() && 
                                            <Grid item xs={12} className={globalStyles.fullwidth}>
                                                <Accordion className={clsx(styles.inputAccordion, globalStyles.fullwidth, globalStyles.maxWidthFull)}>
                                                    <AccordionSummary
                                                        expandIcon={<ExpandMoreIcon />}
                                                        aria-controls="yourInput-content"
                                                        id="yourInput-header"
                                                        className={styles.inputAccordionSummary}
                                                    >
                                                        Your Input
                                                    </AccordionSummary>
                                                    <AccordionDetails className={styles.inputAccordionDetails}>
                                                        <Grid item xs={12}>
                                                            <Grid container spacing={2} className={globalStyles.displayFlex}>
                                                                {payload && payload?.request_parameters && Object.keys(payload?.request_parameters).map((key: string) => {
                                                                    return (
                                                                        <Grid item xs={12} sm={12} md={6} lg={getParamGridSize()}>
                                                                            <Grid container gap={1} className={clsx(globalStyles.displayFlexStyle, globalStyles.flexColumn)}>
                                                                                <Grid item className={clsx(globalStyles.tertiaryFontSize, globalStyles.secondaryFontWeight, globalStyles.greyColor)}>
                                                                                    {key}
                                                                                </Grid>
                                                                                <Grid item className={clsx(globalStyles.tertiaryFontSize, globalStyles.secondaryFontWeight)}>
                                                                                    {payload?.request_parameters[key]}
                                                                                </Grid>    
                                                                            </Grid>
                                                                        </Grid>
                                                                    );
                                                                })}
                                                            </Grid>
                                                        </Grid>
                                                    </AccordionDetails>
                                                </Accordion>
                                            </Grid>
                                        }

                                        <Grid
                                            item
                                            xs={12}
                                            className={clsx(globalStyles.fullwidth, styles.smatAssistStatusBar)}
                                            sx={{
                                                backgroundColor: getSmartAssistStatusInfo(flagRequestFailed, functionCallingResponse)?.bgColor,
                                                border: `1px solid color-mix(in srgb, ${getSmartAssistStatusInfo(flagRequestFailed, functionCallingResponse)?.bgColor} 90%, black)`
                                            }}
                                        >
                                            <Grid container className={clsx(globalStyles.displayFlex, globalStyles.justifyContentSpaceBetween)} gap={2}>
                                                <Grid item>
                                                    <Grid container gap={1} className={globalStyles.displayFlex}>
                                                        <Grid item>
                                                            {getSmartAssistStatusInfo(flagRequestFailed, functionCallingResponse)?.icon}
                                                        </Grid>
                                                        <Grid item>
                                                            <Grid container direction="column">
                                                                <Grid item>
                                                                    <Typography className={clsx(globalStyles.secondaryFontSize, globalStyles.primaryFontWeight, getSmartAssistStatusInfo(flagRequestFailed, functionCallingResponse)?.className)}>
                                                                        {getSmartAssistStatusInfo(flagRequestFailed, functionCallingResponse)?.statusTitle}
                                                                    </Typography>
                                                                </Grid>
                                                                <Grid item>
                                                                    <Typography className={clsx(globalStyles.tertiaryFontSize, globalStyles.secondaryFontWeight, globalStyles.greyColor)}>
                                                                        {getSmartAssistStatusInfo(flagRequestFailed, functionCallingResponse)?.statusSubTitle}
                                                                    </Typography>
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                                <Grid item className={styles.smartAssistStatusAction} onClick={handleClearAndRestart}>
                                                    Clear and Restart
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        
                                        {functionCallingResponse && 
                                            <Grid item className={globalStyles.fullwidth}>
                                                <Grid container className={`${globalStyles.flexColumn}`} gap={"10px"}>
                                                    <Grid item>
                                                        <Typography className={whatsAppCampaignStyles.assignValuesTitle}>
                                                            Response
                                                        </Typography>
                                                    </Grid>
                                                    {typeof functionCallingResponse == "object" ? 
                                                        <Grid item className={clsx(globalStyles.maxWidthFull, styles.functionCallingResponseTable)}>
                                                            <JsonToTable json={functionCallingResponse} />
                                                        </Grid>
                                                        : 
                                                        <Typography className={clsx(globalStyles.secondaryFontSize, globalStyles.secondaryFontWeight)}>
                                                            {functionCallingResponse}
                                                        </Typography>
                                                        
                                                    }
                                                </Grid>
                                            </Grid>
                                        }
                                    </Grid>
                                </Grid>
                            </>
                        }

                    </Grid>
                </Grid>

                <Grid item mt={2} mb={3}>
                    <Grid container justifyContent="center" gap={2}>
                        <GlobalButton
                            className="borderedButtonStyle"
                            buttonText="Close"
                            sx={{ width: "120px" }}
                            onClick={() => setFlagRunDataConnectorToolPopup(false)}
                        />

                        <GlobalButton
                            className="primaryButtonStyle"
                            buttonText="Run Tool"
                            sx={{ width: "120px" }}
                            disabled={checkDisableRunToolBtn()}
                            onClick={onClickOfRunTool}
                        />
                    </Grid>
                </Grid>

            </Grid>
        </>
    )
}

export default SmartAssistRunToolPopup
